import { render, staticRenderFns } from "./NextCourses.vue?vue&type=template&id=37f9e66b&scoped=true&"
import script from "./NextCourses.vue?vue&type=script&lang=js&"
export * from "./NextCourses.vue?vue&type=script&lang=js&"
import style0 from "./NextCourses.vue?vue&type=style&index=0&id=37f9e66b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9e66b",
  null
  
)

export default component.exports